
import asicflow_logo from '../assets/img/logos/asicflow_logo.png'
import { Link } from 'react-router-dom'

function Footer() {
  return (
    <footer className="py-4 bg-light">
      <div className="container">
        <div className="row justify-content-between pt-4 pb-3 pb-lg-5">
          <div className="col-12 col-lg-7">
            <img
              alt="ASICFlow Logo"
              className="img-fluid mb-3"
              src={asicflow_logo}
              width={300}
            />
            <p className="mb-3">
                <strong>Open access to the best open-source chip design tools.</strong><br />
                Find, explore, and build with CMOS, GaN, Photonics, and MEMS tools—no licenses, no friction.
            </p>
            {/*<div className="mb-3">
              <a className="me-2" href="#">
                <svg className="bi bi-pinterest text-primary" fill="currentColor" height="16" viewBox="0 0 16 16" width="16">
                  <path d="M8 0a8 8 0 0 0-2.915 15.452c-.07-.633-.134-1.606.027-2.297..." />
                </svg>
              </a>
              <a className="me-2" href="#">
                <svg className="bi bi-twitter text-primary" fill="currentColor" height="16" viewBox="0 0 16 16" width="16">
                  <path d="M5.026 15c6.038 0 9.341-5.003 9.341-9.334..." />
                </svg>
              </a>
              <a className="me-2" href="#">
                <svg className="bi bi-facebook text-primary" fill="currentColor" height="16" viewBox="0 0 16 16" width="16">
                  <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05..." />
                </svg>
              </a>
            </div>*/}
          </div>

          <div className="col-12 col-lg-2 small text-lg-end mb-4 mb-lg-0 pt-1">
            <p className="mb-1"><Link className="text-dark text-decoration-none" to="/">Home</Link></p>
            <p className="mb-1"><Link className="text-dark text-decoration-none" to="/news">News</Link></p>
            <p className="mb-1"><Link className="text-dark text-decoration-none" to="/blog">Blog</Link></p>
            <p className="mb-0"><Link className="text-dark text-decoration-none" to="/tools">Tools</Link></p>
            
          </div>

          <div className="col-12 col-lg-3 pt-1 small text-lg-end">
            <p className="mb-1">Rubenshof 21 </p>
            <p className="mb-1">3300, Tienen</p>
            <p className="mb-1">Tel: +32 496 03 1994</p>
            <p className="mb-0"><Link className="text-dark text-decoration-none" to="mailto:onur.ates@gmx.com">onur.ates@gmx.com</Link></p>
          </div>
        </div>

        {/*<div className="border-top d-lg-none"></div>
        <div className="d-lg-flex justify-content-between py-3">
          <div className="small">
            <span className="d-block d-lg-inline text-muted mb-2 mb-lg-0 me-lg-5">© 2023 ASICFlow. All rights reserved.</span>
            <a className="d-block d-lg-inline text-muted mb-2 mb-lg-0 me-lg-5" href="#">Privacy Policy</a>
            <a className="d-block d-lg-inline text-muted mb-2 mb-lg-0 me-lg-5" href="#">Terms of Service</a>
          </div>
          <div className="small">
            <span className="text-muted"><a className="text-muted" href="#">Proudly built with Bootstrap</a></span>
          </div>
        </div>*/}
      </div>
    </footer>
  );
}

export default Footer;
